// Директива для того чтобы привызявать любой всплывающий блок к body, но с координатами родительского элемента
function calculatePosition(dropdownList, component, { width, top, left }) {
  dropdownList.style.top = top;
  dropdownList.style.left = left;
  dropdownList.style.width = width;
}

export default {
  bind(el, binding, { context }) {
    handlePosition(el, binding, { context });
  },
  update(el, binding, { context }) {
    handlePosition(el, binding, { context });
  },

  unbind(el, binding) {
    const { value } = binding;
    if (value.id) {
      if (el.unbindPosition && typeof el.unbindPosition === 'function') {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};

function handlePosition(el, binding, { context }) {
  const { value } = binding;
  const isOnce = value.once || false;

  if (isOnce) return; // параметр определяет будет ли у директивы updated

  if (value.id) {
    // value.id - это значение указанное в директиве v-append-to-body="value" (элемент c ref в компоненте к которому привязывать координаты)
    // Если $refs массивом, то берем первый элемент в массиве. Затем высчитываем его координаты.
    const element = context.$refs[value.id].length !== undefined ? context.$refs[value.id][0] : context.$refs[value.id];

    const { height, top, left, width } = element.getBoundingClientRect();
    const modal = el.getBoundingClientRect(); // для определения высоты модалки moda.height

    // Определяем будет ли выпадать "модалка" вниз или вверх.
    // Если модалка "уходит вниз за окно", то направление нужно сменить на вверх
    const isDirectionUp = top + modal.height > window.innerHeight && modal.height < top ? true : false;

    let scrollX = window.scrollX;
    let scrollY = window.scrollY;

    el.unbindPosition = calculatePosition(el, context, {
      width: width + 'px',
      left: scrollX + left + 'px',
      // top: scrollY + top + height + 'px' // Без isDirectionUp, пока оставил
      top: isDirectionUp ? scrollY + top - modal.height + 'px' : scrollY + top + height + 'px'
    });

    document.body.appendChild(el);
  }
}
